var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "navbar-right";
},"3":function(container,depth0,helpers,partials,data) {
    return "";
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(data && lookupProperty(data,"first")),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":21},"end":{"line":14,"column":48}}})) != null ? stack1 : "")
    + "\">\n            <a href=\"#"
    + alias3(alias2((depths[1] != null ? lookupProperty(depths[1],"position") : depths[1]), depth0))
    + "-"
    + alias3(alias2((data && lookupProperty(data,"index")), depth0))
    + "\" aria-controls=\"messages\" role=\"tab\" data-toggle=\"tab\">"
    + alias3(__default(require("../helpers/t.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"t","hash":{},"data":data,"loc":{"start":{"line":15,"column":104},"end":{"line":15,"column":119}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"hasInfo") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":120},"end":{"line":15,"column":173}}})) != null ? stack1 : "")
    + "</a>\n          </li>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "active";
},"8":function(container,depth0,helpers,partials,data) {
    return "<span class=\"info\"></span>";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div role=\"tabpanel\" class=\"tab-pane"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(data && lookupProperty(data,"first")),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":44},"end":{"line":25,"column":72}}})) != null ? stack1 : "")
    + "\" id=\""
    + alias3(alias2((depths[1] != null ? lookupProperty(depths[1],"position") : depths[1]), depth0))
    + "-"
    + alias3(alias2((data && lookupProperty(data,"index")), depth0))
    + "\">"
    + alias3(__default(require("../helpers/t.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"t","hash":{},"data":data,"loc":{"start":{"line":25,"column":106},"end":{"line":25,"column":121}}}))
    + "</div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    return " active";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"btn btn-default toggle-side-panel toggle-side-panel-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"position") : depth0), depth0))
    + " toggle-side-panel-out\">\n  <i class=\"fa "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "\" aria-hidden=\"true\"></i>\n</button>\n\n<div class=\"side-panel side-panel-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"position") : depth0), depth0))
    + "\">\n  <button class=\"btn btn-default toggle-side-panel toggle-side-panel-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"position") : depth0), depth0))
    + "\">\n    <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n  </button>\n\n  <nav class=\"nav\">\n    <div class=\"container-fluid\">\n      <ul class=\"nav nav-tabs "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isLeft") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":12,"column":30},"end":{"line":12,"column":71}}})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"views") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":17,"column":17}}})) != null ? stack1 : "")
    + "      </ul>\n    </div>\n  </nav>\n\n  <div class=\"side-panel-content out\">\n    <div class=\"tab-content\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"views") : depth0),{"name":"each","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":6},"end":{"line":26,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n  </div>\n</div>\n";
},"useData":true,"useDepths":true});


//////////////////
// WEBPACK FOOTER
// /src/views/SidePanelView.hbs
// module id = 2060
// module chunks = 0